$(document).ready(function() {

  var parent = "";

  $('form').length ? parent = 'form' : parent = 'col-12';

  if($(window).height() < 700) {
    $('.form-nav').addClass('fixed-bottom');
    $('.form-nav').parent(parent).addClass('with-sticky-nav');
  }

  $(window).on('resize', function() {
    if($(window).height() < 700) {
      $('.form-nav').parent(parent).addClass('with-sticky-nav');
      $('.form-nav').addClass('fixed-bottom');
    } else {
      $('.form-nav').parent(parent).removeClass('with-sticky-nav');
      $('.form-nav').removeClass('fixed-bottom');
    }
  });

});
